import React from 'react';
import I18n from 'i18n-js';

import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { ButtonSize, ButtonVariant } from '@reverbdotcom/cadence/components/RCButton/styling';
import { PrinterIcon } from '@phosphor-icons/react';
import {
  RCButton,
  RCButtonLink,
  RCModal,
} from '@reverbdotcom/cadence/components';

interface IProps {
  size?: ButtonSize;
  variant?: ButtonVariant;
  printerIcon?: boolean;
  isUspsShippingLabel: boolean;
  labelPrintUrl: string;
}

export default function PrintShippingLabelModalButton({
  size = 'small',
  variant = 'muted',
  printerIcon = false,
  isUspsShippingLabel,
  labelPrintUrl,
}: IProps) {
  const [isOpen, setIsOpen] = React.useState(false);

  if (!isUspsShippingLabel) {
    return (
      <RCButtonLink
        fullWidth
        size={size}
        variant={variant}
        renderLink={c => (
          <CoreLink to={labelPrintUrl} target="_blank">
            {c}
          </CoreLink>
        ) as React.ReactElement}
      >
        {printerIcon && <PrinterIcon />}
        {I18n.t('discovery.selling.order.printShippingLabelButton.printLabel')}
      </RCButtonLink>
    );
  }

  return (
    <>
      <RCButton
        fullWidth
        size={size}
        variant={variant}
        onClick={() => setIsOpen(true)}
      >
        {printerIcon && <PrinterIcon />}
        {I18n.t('discovery.selling.order.printShippingLabelButton.printLabel')}
      </RCButton>
      <RCModal
        title={I18n.t('discovery.selling.order.printShippingLabelButton.modalTitle')}
        isOpen={isOpen}
        onOpenChange={(state) => {
          if (state === false) setIsOpen(false);
        }}
        actions={{
          primary: {
            buttonText: I18n.t('discovery.selling.order.printShippingLabelButton.modalPrimaryButtonText'),
            onClick: () => window.location.assign(labelPrintUrl),
            closeOnClick: true,
          },
          secondary: true,
        }}
      >
        <p>
          {I18n.t('discovery.selling.order.printShippingLabelButton.modalContentP1')}
        </p>
        <p className="mb-0">
          {I18n.t('discovery.selling.order.printShippingLabelButton.modalContentP2')}
        </p>
      </RCModal>
    </>
  );
}
